<template>
  <div class="maintenance-page">
    <div class="maintenance-card">
      <VaIcon name="mso-build" size="4rem" color="primary" class="maintenance-icon" />
      <h1 class="maintenance-title">Under maintenance</h1>
      <p class="maintenance-message">We're performing scheduled maintenance. Please check back shortly.</p>
      <VaButton color="primary" @click="refresh">Refresh page</VaButton>
    </div>
  </div>
</template>

<script lang="ts" setup>
const refresh = () => {
  window.location.reload()
}
</script>

<style lang="scss" scoped>
.maintenance-page {
  min-height: 100vh;
  width: 100%;
  background: var(--va-background-primary);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
}

.maintenance-card {
  text-align: center;
  max-width: 24rem;
}

.maintenance-icon {
  margin-bottom: 1rem;
  opacity: 0.9;
}

.maintenance-title {
  font-size: 1.5rem;
  font-weight: 600;
  color: var(--va-on-background-primary);
  margin: 0 0 0.5rem;
}

.maintenance-message {
  font-size: 0.9375rem;
  color: var(--va-on-background-secondary);
  margin: 0 0 1.5rem;
  line-height: 1.5;
}
</style>
